export default __webpack_public_path__ + "static/media/tailwindcss-mark.cb8046c1.svg";